package top.wcpe.allincore.dsl.ir.model.overlay

import top.wcpe.allincore.dsl.ir.model.UiIr
import top.wcpe.allincore.dsl.ir.model.internal.ReadOnlyOrderedMap

/**
 * 可渲染内容引用。
 */
abstract class ContentRef private constructor() {

    /** 字符串内容。 */
    class Text(text: String?) : ContentRef() {
        val text: String = text ?: throw NullPointerException("text")

        override fun equals(other: Any?): Boolean {
            if (this === other) return true
            if (other !is Text) return false
            return text == other.text
        }

        override fun hashCode(): Int = text.hashCode()

        override fun toString(): String = "ContentRef.Text{" + text + "}"
    }

    /** 内联 IR 子树。 */
    class Inline(rootIr: UiIr?) : ContentRef() {
        val rootIr: UiIr = rootIr ?: throw NullPointerException("rootIr")

        override fun equals(other: Any?): Boolean {
            if (this === other) return true
            if (other !is Inline) return false
            return rootIr == other.rootIr
        }

        override fun hashCode(): Int = rootIr.hashCode()

        override fun toString(): String =
            "ContentRef.Inline{screenId=" + rootIr.screenId +
                ",overlays=" + rootIr.overlayDescriptors.size +
                ",rootId=" + rootIr.root.id + "}"
    }

    /** 组件引用。 */
    class Component(name: String?, props: Map<String, Any?>?) : ContentRef() {
        val name: String = name ?: throw NullPointerException("name")
        val props: Map<String, Any?> = ReadOnlyOrderedMap(copyProps(props))

        override fun equals(other: Any?): Boolean {
            if (this === other) return true
            if (other !is Component) return false
            return name == other.name && props == other.props
        }

        override fun hashCode(): Int {
            var result = 1
            result = 31 * result + name.hashCode()
            result = 31 * result + props.hashCode()
            return result
        }

        override fun toString(): String = "ContentRef.Component{" + name + ",props=" + props.keys + "}"

        private companion object {
            fun copyProps(props: Map<String, Any?>?): LinkedHashMap<String, Any?> {
                val src = props ?: throw NullPointerException("props")
                val copied = LinkedHashMap<String, Any?>(src.size)
                for ((key, value) in src) {
                    // Stage C 仅保证外层 map 防御性不可变；值沿用现有 IR scalar 约定。
                    copied[key ?: throw NullPointerException("props key")] = value
                }
                return copied
            }
        }
    }
}
